import * as React from 'react';

import { HeadTr, ItemTd, ItemTr } from './ReceiptItem.style';
import { ReceiptItemDescription } from './ReceiptItemDescription';
import { ReceiptItemDiscount } from './ReceiptItemDiscount';
import { ReceiptItemNote } from './ReceiptItemNote';
import { ReceiptItemQuantity } from './ReceiptItemQuantity';
import { ReceiptItemSubTotal } from './ReceiptItemSubTotal';

import type { SaleLine } from '~/renderer/store/receipt/types';

interface ReceiptItemProps {
  saleLine: SaleLine;
  lineNumber: number;
  hasUntaxedItems: boolean;
  isGroupedItemHead?: boolean;
  isGroupedItem?: boolean;
  hasGroupedItems?: boolean;
  isLastGroupedItem?: boolean;
  description: string;
}

const ReceiptItem: React.FunctionComponent<ReceiptItemProps> = ({
  saleLine,
  lineNumber,
  hasUntaxedItems = false,
  isGroupedItemHead = false,
  isGroupedItem = false,
  hasGroupedItems = false,
  isLastGroupedItem = false,
  description,
}) => {
  const note = saleLine.Note?.note ?? '';
  const {
    saleLineID: id,
    tax,
    Discount: discount,
    calcLineDiscount: lineDiscount,
    displayableSubtotal,
    normalUnitPrice,
    unitQuantity: quantity,
  } = saleLine;
  const Tr = isGroupedItem ? ItemTr : HeadTr;

  return (
    <Tr
      key={id}
      lineNumber={lineNumber}
      isGroupedItemHead={isGroupedItemHead}
      hasGroupedItems={hasGroupedItems}
      isLastGroupedItem={isLastGroupedItem}
    >
      {!isGroupedItemHead ? (
        <ReceiptItemQuantity
          isGroupedItem={isGroupedItem}
          isGroupedItemHead={isGroupedItemHead}
          lineNumber={lineNumber}
          quantity={quantity}
        />
      ) : null}
      <ItemTd
        as="td"
        colSpan={isGroupedItemHead ? 2 : undefined}
        isGroupedItem={isGroupedItem}
        pl={isGroupedItemHead ? 3 : 0}
        pt={isGroupedItem ? 0 : 2}
        pb={isGroupedItem ? 0 : 2}
        width="100%"
      >
        <ReceiptItemDescription
          lineNumber={lineNumber}
          description={description}
          tax={isGroupedItemHead ? true : tax}
          hasUntaxedItems={hasUntaxedItems}
          isGroupedItem={isGroupedItem}
        />
        <ReceiptItemDiscount
          discount={discount}
          lineDiscount={lineDiscount}
          lineNumber={lineNumber}
        />
        <ReceiptItemNote
          isGroupedItemHead={isGroupedItemHead}
          lineNumber={lineNumber}
          note={note}
          description={description}
          tax={tax}
          hasUntaxedItems={hasUntaxedItems}
        />
      </ItemTd>
      {!isGroupedItemHead ? (
        <ReceiptItemSubTotal
          isGroupedItemHead={isGroupedItemHead}
          isGroupedItem={isGroupedItem}
          normalUnitPrice={normalUnitPrice}
          quantity={quantity}
          displayableSubTotal={displayableSubtotal}
          lineNumber={lineNumber}
        />
      ) : null}
    </Tr>
  );
};

export default ReceiptItem;
